module.exports = __webpack_public_path__ + "static/scrabblista-mobile-4.e3d31382.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/scrabblista/img/scrabblista-mobile-4.png
// module id = 628
// module chunks = 230197332751855